// extracted by mini-css-extract-plugin
export default {"label":"label_label__1f6zS","required":"label_required__clvTf"};